/** What a month in a band's bars opens: the Every figure drawer for that month - design uplift U5.
 *
 * It no longer navigates. The page stays where it is, its period stays what it was, and the drawer
 * opens on the figures that overlap the month (`monthBreakdown.ts` resolves the key). Pages without a
 * drawer of their own are not offered the bars' click.
 */

import { monthBreakdownKey } from "./monthBreakdown";
import type { Screen } from "../useScreen";

export { monthBounds } from "./monthBreakdown";

export function useOpenMonth(screen: Pick<Screen, "openBreakdown">): (month: string) => void {
  return (month) => {
    screen.openBreakdown(monthBreakdownKey(month));
  };
}
